import { render, staticRenderFns } from "./ServicePoints.vue?vue&type=template&id=2d5fb3d6&scoped=true"
import script from "./ServicePoints.vue?vue&type=script&lang=js"
export * from "./ServicePoints.vue?vue&type=script&lang=js"
import style0 from "./ServicePoints.vue?vue&type=style&index=0&id=2d5fb3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5fb3d6",
  null
  
)

export default component.exports